<template>
  <header class="header" :style="[ route.name !== 'home' ? {backgroundColor: '#FFF3E4'} : '' ]">
    <div class="container">
      <div class="header__wrapper">
        <router-link :to="{ name: 'home' }">
          <img class="header__logo" src="@images/logo.png" alt="logo">
        </router-link>
        <nav class="header__nav">
          <p class="header__nav-item" @click="scrollTo('services', 'home')">Services</p>
          <p class="header__nav-item" @click="scrollTo('about', 'home')">About Us</p>
          <p class="header__nav-item" @click="scrollTo('partner', 'home')">Partner up</p>
          <p class="header__nav-item" @click="scrollTo('benefits', 'home')">Benefits</p>
          <button class="header__button" @click="scrollTo('contact', 'home')">Let's Talk</button>
        </nav>
        <svg class="header__mobile" @click="isMenuActive = !isMenuActive" width="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g id="Menu / Menu_Alt_01">
            <path id="Vector" d="M12 17H19M5 12H19M5 7H19" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </g>
        </svg>
      </div>
    </div>
    <base-menu :isActive="isMenuActive" @close-modal="handleCloseModal" />
  </header>
</template>

<script setup>
import {scroll} from "@/core/helpers/scrollTo.js";
import {useRoute, useRouter} from "vue-router";
import BaseMenu from "@/components/base/base-menu.vue";
import {ref} from "vue";

const router = useRouter()
const route = useRoute()

const scrollTo = (id, routeName) => {
  if (route.name === routeName) {
    scroll(id);
  } else {
    router.push({
      name: 'home'
    }).then(scroll(id, 300));
  }
}

const isMenuActive = ref(false)
const handleCloseModal = () => {
  isMenuActive.value = false;
}
</script>

<style lang="scss" scoped>
.header {
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  width: 100vw;
  padding-block: 30px;

  &__wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__nav {
    display: flex;
    align-items: center;
    gap: 70px;

    &-item {
      cursor: pointer;
      transition: 0.2s;
      color: #252641;
      font-size: 16px;
      font-weight: 400;
      letter-spacing: 0.44px;

      @include hover {
        color: #0e0f1a;
      }
    }
  }

  &__button {
    cursor: pointer;
    border-radius: 80px;
    background-color: #F48C06;
    padding: 6px 40px;
    transition: 0.2s;

    color: $white;
    font-size: 16px;
    font-weight: 600;

    @include hover {
      background-color: #ff9f28;
    }
  }

  &__mobile {
    display: none;
    flex-shrink: 0;
  }
}

@media (max-width: 1300px) {
  .header {
    &__nav {
      gap: 30px;
    }
  }
}

@media (max-width: 1100px) {
  .header {
    &__nav {
      display: none;
    }

    &__mobile {
      display: flex;
    }
  }
}

@media (max-width: 500px) {
  .header {
    &__logo {
      width: 300px;
    }
  }
}
</style>